export const UPDATE_CURRENT_KEY = 'UPDATE_CURRENT_KEY';
export const UPDATE_SWITCH_FROM_KEY = 'UPDATE_SWITCH_FROM_KEY';
export const UPDATE_ONLY_SHOW_RECOMMENDED = 'UPDATE_ONLY_SHOW_RECOMMENDED';
export const UPDATE_GROUP_BY = 'UPDATE_GROUP_BY';
